import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-tipo-cliente',
  templateUrl: './dialog-tipo-cliente.component.html',
  styleUrls: ['./dialog-tipo-cliente.component.scss']
})
export class DialogTipoClienteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/cliente-components/tipocliente/dialog-tipo-cliente/dialog-tipo-cliente.component.ts